/* eslint-disable no-lonely-if */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable object-curly-spacing */
/* eslint-disable function-paren-newline */
/* eslint-disable quotes */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line react/jsx-indent
/* eslint-disable no-shadow */
/* eslint-disable-next-line no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */

import React, {
    useContext, useEffect, useState, useCallback, useRef
} from 'react';
import _, { filter } from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext, LocaleService } from '@jutro/locale';
import {
    Chevron, Icon, ModalNextProvider, Button
} from '@jutro/components';
import appConfig from 'app-config';
import DisplayPopup from '../../common/view-popup-message/view-popup-message.jsx';
import uiMetadata from '../../claim-details/claim-related-documents/claim-related.metadata.json5';
import styles from '../../claim-details/claim-related-documents/claim-related.module.scss';
import messages from '../../claim-details/claim-related-documents/claim-related.messages.js';
import FeedbackLink from '../../services/FeedbackLink.js';
import SurveyLink from '../../services/SurveyLink.js';
import LoaderComponent from '../../common/loader/loader';
import appMessages from '../../../app/App.messages.js';
import OSBCClaimService from '../../services/OSBCClaimService.js';
import UtilService from '../../services/UtilService.js';
import vector from '../../../assets/images/vector.svg';
import wsibDatePicker from '../../components/wsib-date-picker/wsib-date-picker.jsx';
import tooltip from '../../../assets/images/tooltip.svg';
import showQueuedModal from '../../common/modal-queue/modalQueue';
import { trackException, trackEvent } from '../../common/application-insight/application-insight';

const ClaimDocumentComponent = () => {
    const translator = useContext(TranslatorContext);
    const [isLoading, setIsLoading] = useState(false);
    const [claimDocuments, setClaimDocuments] = useState([]);
    const [dropdownValues, setDropdownValues] = useState(translator(messages.dropdownPlaceholder));
    const [serverError, setServerError] = useState(false);
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [isMultiDownloadInProgress, setIsMultiDownloadInProgress] = useState(false);
    const [checkboxAnnounce, setCheckboxAnnounce] = useState('');
    const multiDownloadInProgressRef = useRef(false);
    const MAX_SELECTION = 5;
    const [multiDownloadWarningMSG, setMultiDownloadWarningMSG] = useState('09');
    const claimNumber = UtilService.fetchClaimNumber();
    const [dataTableFilter, setDataTableFilter] = useState([]);
    const [searchFilter, setSearchFilter] = useState(undefined);
    const [fromDateError, setFromDateError] = useState(false);
    const [fromError, setFromError] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [selectedFromDate, setSelectedFromDate] = useState({ rawFromDate: '', fromDate: null });
    const [selectedToDate, setSelectedToDate] = useState({ rawToDate: '', toDate: null });
    const [error, setError] = useState({});
    const [searchFilters, setSearchFilters] = useState({
        documentCategory: '',
        documentDescription: '',
        documentSource: '',
        sender: '',
    });
    const successfulDocumentIdsRef = useRef(new Set());
    const [callLoadData, setCallLoadData] = useState(false);
    const [isShowDefaultViewMessage, setIsShowDefaultViewMessage] = useState(false);
    const [MSG, setMSG] = useState('datatableNdDataText');
    const [config, setConfig] = useState({
        filterValue: '',
        page: 0,
        pageSize: 10,
        sorted: []
    });
    const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
    const history = useHistory();
    const lang = LocaleService.getStoredLanguage();
    const { DOCUMENT_CATEGORY, DOCUMENT_SOURCE } = appConfig;
    const currentLanguage = ['fr', 'FR', 'fr-FR'].includes(LocaleService.getStoredLanguage()) ? 'Fr' : '';
    const [isDocCatMenuOpen, setIsDocCatMenuOpen] = useState(false);
    const [isAccord, setIsAccord] = useState(false);

    const searchByValues = [
        {
            searchByName: `${translator(messages.dropdownPlaceholder)}`,
        },
        {
            searchByName: `${translator(messages.dropDownDocumentCategory)}`,
        },
        {
            searchByName: `${translator(messages.dropDownDocumentDescription)}`,
        },
        {
            searchByName: `${translator(messages.dropDownDocumentSource)}`,
        },
        {
            searchByName: `${translator(messages.dropDownDocumentSender)}`,
        },
        {
            searchByName: `${translator(messages.dropDownDateReceived)}`,
        },
    ];

    const buildServerPagedArray = (rows, offset, total) => {
        const arr = Array.from({ length: total }, (_, idx) => ({
            __placeholder: true,
            _subRows: [],
            publicID: `__placeholder_${idx}`
        }));
        rows.forEach((row, i) => {
            arr[offset + i] = { ...row, _subRows: row?._subRows || [] };
        });
        return arr;
    };
    const tryToISODate = (value) => {
        if (!value || typeof value !== 'string') return null;
        const trimmed = value.trim();
        if (!trimmed) return null;

        const d = new Date(trimmed);
        // valid date?
        if (!Number.isNaN(d.getTime())) return d.toISOString();

        return null;
    };

    const buildBasicSearchCriteria = ({
        dropdownValues, searchFilter, lang, translator
    }) => {
        const keyword = (searchFilter || '').trim();
        if (!keyword) return null;

        const isFr = lang?.toLowerCase().startsWith('fr');

        // Normalize selected dropdown
        const selected = (dropdownValues || '').toLowerCase();

        // These labels exist in your file as dropDown values
        const labelSearchAll = translator(messages.dropdownPlaceholder).toLowerCase();
        const labelDocCategory = translator(messages.dropDownDocumentCategory).toLowerCase();
        const labelDocDescription = translator(messages.dropDownDocumentDescription).toLowerCase();
        const labelDocSource = translator(messages.dropDownDocumentSource).toLowerCase();
        const labelDocSender = translator(messages.dropDownDocumentSender).toLowerCase();
        const labelDateReceived = translator(messages.dropDownDateReceived).toLowerCase();

        // Base criteria: backend requires this
        const criteria = { basicSearch: true };

        // DATE: backend expects ISO in datePostedEn/datePostedFr
        const dateISO = tryToISODate(keyword);

        // Search All
        if (selected === labelSearchAll) {
            if (isFr) criteria.searchAllFr = keyword;
            else criteria.searchAllEn = keyword;
            return criteria;
        }

        // Specific selection
        if (selected === labelDocDescription) {
            if (isFr) criteria.docDescriptionFr = keyword;
            else criteria.docDescription = keyword;
            return criteria;
        }

        if (selected === labelDocCategory) {
            if (isFr) criteria.docCategoryFr = keyword;
            else criteria.docCategoryEn = keyword;
            return criteria;
        }

        if (selected === labelDocSource) {
            if (isFr) criteria.channelFr = keyword;
            else criteria.channelEn = keyword;
            return criteria;
        }

        if (selected === labelDocSender) {
            if (isFr) criteria.senderFr = keyword;
            else criteria.sender = keyword;
            return criteria;
        }

        if (selected === labelDateReceived) {
            if (isFr) criteria.datePostedFr = keyword;
            else criteria.datePostedEn = keyword;
            return criteria;
        }

        // Default fallback: treat as Search All
        if (isFr) criteria.searchAllFr = keyword;
        else criteria.searchAllEn = keyword;

        return criteria;
    };

    const formatLocalDate = (date) => {
        if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) {
            return null;
        }
        const pad = (value) => String(value).padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T00:00:00`;
    };

    const [totalRecordCount, setTotalRecordCount] = useState(0);
    const unwrapResult = (resp) => resp?.result ?? resp;
    const computeServerMode = (total, rowsLen) => typeof total === 'number' && typeof rowsLen === 'number' && total !== rowsLen;
    const [shouldFetchFromServer, setShouldFetchFromServer] = useState(false);
    const [showBasicSearchLimitWarning, setShowBasicSearchLimitWarning] = useState(false);
    const SORT_FIELD_MAP = {
        en: {
            from: 'docCategory',
            documentDescription: 'docDescription',
            documentSource: 'channel',
            sender: 'sender',
            datePosted: 'datePosted',
        },
        fr: {
            from: 'docCategoryFr',
            documentDescription: 'docDescriptionFr',
            documentSource: 'channelFr',
            sender: 'senderFr',
            datePosted: 'datePosted',
        },
    };

    const isIOSSafari = () => {
        const ua = window.navigator.userAgent;
        return /iP(ad|hone|od)/i.test(ua)
            && /WebKit/i.test(ua)
            && !/CriOS|FxiOS|EdgiOS/i.test(ua);
    };

    const lastSortRef = useRef([]);

    const serverQueryRef = useRef({
        documentSearchCriteria: null,
        orderBy: null,
        orderByDescending: null
    });

    const serverSortRef = useRef({
        field: null,
        desc: false
    });

    useEffect(() => {
        UtilService.publishGA('Page View', 'VD_OSPC_ViewClmRelDoc_PageView', LocaleService.getStoredLanguage());
        const landingTime = new Date().getTime();
        return () => {
            const exitTime = new Date().getTime();
            const diff = exitTime - landingTime;
            UtilService.publishAccountTimeSpent('Time Spent', 'VD_OSPC_ViewClmReldDoc_TimeSpent', diff, LocaleService.getStoredLanguage());
        };
    }, []);

    const isPageActiveRef = useRef(true);

    useEffect(() => {
        const disableEllipsis = () => {
            const navBtns = document.querySelectorAll(
                '.jut__Pagination__paginationNav .jut__Pagination__paginationSelect'
            );
            navBtns.forEach((btn) => {
                btn.setAttribute('tabindex', '-1');
                btn.setAttribute('aria-hidden', 'true');
            });
        };

        disableEllipsis();

        const observer = new MutationObserver(disableEllipsis);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        return () => {
            // This runs when user navigates away
            isPageActiveRef.current = false;
        };
    }, []);

    useEffect(() => {
        multiDownloadInProgressRef.current = isMultiDownloadInProgress;
    }, [isMultiDownloadInProgress]);

    const sortMergedDates = useCallback((a, b) => {
        const date1 = new Date(a.dateReceived);
        const date2 = new Date(b.dateReceived);
        if (date1 > date2) return -1;
        if (date1 < date2) return 1;
        return 0;
    }, []);

    const renderClaimDocumentLink = React.useCallback((e) => {
        // eslint-disable-next-line no-unused-expressions
        e?.preventDefault?.();
        history.push(`/documentHistory/${claimNumber}`);
    }, [history, claimNumber]);

    const renderSendMessageLink = React.useCallback((e) => {
        // eslint-disable-next-line no-unused-expressions
        e?.preventDefault?.();
        history.push(`/sendmessage/${claimNumber}`);
    }, [history, claimNumber]);

    const renderFaqLink = React.useCallback((e) => {
        // eslint-disable-next-line no-unused-expressions
        e?.preventDefault?.();
        history.push(`/faq-link/${claimNumber}`);
    }, [history, claimNumber]);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    function customDateFormat(date) {
        return UtilService.customDateFormat(date, LocaleService.getStoredLanguage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onValueChangeOfDropdown = useCallback((res) => {
        setDropdownValues(res);
        setSearchFilter('');
        setShowBasicSearchLimitWarning(false);
        if (!shouldFetchFromServer && !_.isEmpty(claimDocuments)) {
            setDataTableFilter(claimDocuments);
        } else {
            serverQueryRef.current.documentSearchCriteria = null;
            serverQueryRef.current.orderBy = null;
            serverQueryRef.current.orderByDescending = null;
            serverSortRef.current.field = null;
            serverSortRef.current.desc = false;
            lastSortRef.current = [];
            // eslint-disable-next-line no-use-before-define
            getSubmittedDocuments();
        }
    // eslint-disable-next-line no-use-before-define
    }, [claimDocuments, shouldFetchFromServer, getSubmittedDocuments]);


    const showDescriptionModal = (errorCode = _.noop(), count = null) => {
        let title;
        let msg;
        switch (errorCode) {
            case 'TWODOCDOWNLOADFAIL':
                title = translator({ id: 'claim-related.doubleDownloadErrorTitle' });
                msg = translator({ id: 'claim-related.doubleDownloadError' });
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmRelDocMulDwnld_Error', LocaleService.getStoredLanguage());
                break;
            case 'UNPUBLISHEDDOCERR':
                title = translator({ id: 'claim-related.unpublishDownloadErrorTitle' });
                msg = translator({ id: 'claim-related.unpublishDownloadError' });
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmRelDocnotavailable_Error', LocaleService.getStoredLanguage());
                break;
            case 'DOCSCRUBMSG40':
                title = translator(messages.msg40ScrubDoctitle);
                msg = translator(messages.msg40ScrubDocContent);
                break;
            case 'DOCSCRUBMSG41':
                title = translator(messages.msg41ScrubDoctitle);
                msg = translator(messages.msg41ScrubDocContent, {outcome: successFiles, total: total});
                break;
            case 'DOCSCRUBMSG41_1':
                title = translator(messages.msg41ScrubDoctitle);
                msg = `${translator(messages.msg41ScrubDocContent, {outcome: count.outcome, total: count.total})}`;
                break;
            case 'DOCSCRUBMSG41_2':
                title = translator(messages.msg41ScrubDoctitle);
                msg = `${translator(messages.msg41ScrubDocContent, {outcome: 1, total: 2})}`;
                break;
            default:
                title = translator({ id: 'claim-related.singleDownloadErrorTitle' });
                msg = translator({ id: 'claim-related.singleDownloadError' });
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmreldocErrdwnldDoc_Error', LocaleService.getStoredLanguage());
        }
        ModalNextProvider.showModal(
            <DisplayPopup title={title} closeButtonText={translator({ id: 'claim-related.closeText' })} customClassName="modalStyle">
                <p className={styles.PopupSection}>
                    {msg}
                </p>
            </DisplayPopup>
        );
    };

    const getMaxLength = () => {
        if (dropdownValues === translator(messages.from)) {
            return 60;
        }
        return 50;
    };

    const processDocsData = useCallback((claimDocsData) => {
        const timezoneOffset = (new Date()).getTimezoneOffset() * 60000;
        // eslint-disable-next-line no-undef
        let arr = [];
        if (!_.isEmpty(claimDocsData)) {
            arr = claimDocsData.map((e) => {
                e.description = (`${e.documentDescription}\n${e.coverLettersDetails.length > 0 ? '(2 files)' : e.coverLettersDetails}`);
                e.documentCategory = (e.documentCategory);
                e.documentSource = (e.channel);
                return e;
            });
            return arr;
        }
        return arr;
    }, []);

    const getSubmittedDocuments = useCallback((pageConfig = null) => {
        const clmNumber = UtilService.fetchClaimNumber();
        const serviceName = UtilService.getServiceName('claim');

        setIsLoading(true);
        UtilService.publishGA('Error', 'VD_OSPC_ViewClmPgLoadWait_Information', LocaleService.getStoredLanguage());

        if (shouldFetchFromServer && pageConfig) {
            const pageNumber = pageConfig.page ?? 0;
            const pageSize = pageConfig.pageSize || 10;
            const offset = pageNumber * pageSize;

            const sort = (pageConfig.sorted || [])[0];

            if (sort?.id) {
                const mappedField = (SORT_FIELD_MAP[LocaleService.getStoredLanguage()] ?? SORT_FIELD_MAP.en)[sort.id];
                if (mappedField) {
                    serverSortRef.current.field = mappedField;
                    serverSortRef.current.desc = !!sort.desc;
                }
            }

            const orderBy = serverSortRef.current.field || null;
            const orderByDescending = orderBy ? !!serverSortRef.current.desc : null;

            serverQueryRef.current.orderBy = orderBy;
            serverQueryRef.current.orderByDescending = orderByDescending;

            OSBCClaimService.getAllClaimRelatedDocuments(
                clmNumber,
                serviceName,
                {},
                {
                    limit: pageSize,
                    offset,
                    pageNumber,
                    orderBy,
                    orderByDescending,
                    documentSearchCriteria: serverQueryRef.current.documentSearchCriteria
                }
            )
                .then((resp) => {
                    const result = unwrapResult(resp);
                    const rows = processDocsData(result?.claimDocuments || []);
                    const total = (typeof result?.maxNumberOfResults === 'number')
                        ? result.maxNumberOfResults
                        : rows.length;
                    setTotalRecordCount(total);
                    const serverMode = computeServerMode(total, rows.length);
                    setShouldFetchFromServer(serverMode);
                    setDataTableFilter(buildServerPagedArray(rows, offset, total));
                    setConfig((prev) => ({
                        ...prev,
                        page: pageNumber,
                        pageSize,
                        sorted: pageConfig.sorted || [],
                        total
                    }));
                })
                .catch((e) => {
                    trackException('API Error: getAllClaimRelatedDocuments (server paging)', {
                        endpoint: 'getAllClaimRelatedDocuments',
                        claimNumber: clmNumber,
                        response: JSON.stringify(e)
                    });
                    setMSG('serverError');
                    setServerError(true);
                    setDataTableFilter([]);
                })
                .finally(() => setIsLoading(false));

            return;
        }

        OSBCClaimService.getAllClaimRelatedDocuments(
            clmNumber,
            serviceName,
            {},
            {
                limit: 10,
                offset: 0,
                pageNumber: 0,
                orderBy: null,
                orderByDescending: null,
                documentSearchCriteria: null
            }
        )
            .then((resp) => {
                const result = unwrapResult(resp);
                const rows = processDocsData(result?.claimDocuments || []);
                const sortedRows = rows.sort(sortMergedDates);

                const total = (typeof result?.maxNumberOfResults === 'number')
                    ? result.maxNumberOfResults
                    : sortedRows.length;

                setTotalRecordCount(total);
                const serverMode = computeServerMode(total, sortedRows.length);
                setShouldFetchFromServer(serverMode);

                serverQueryRef.current.documentSearchCriteria = null;
                serverQueryRef.current.orderBy = null;
                serverQueryRef.current.orderByDescending = null;
                serverSortRef.current.field = null;
                serverSortRef.current.desc = false;
                lastSortRef.current = [];

                if (serverMode) {
                    setDataTableFilter(buildServerPagedArray(sortedRows, 0, total));
                    setClaimDocuments([]);
                } else {
                    setClaimDocuments(sortedRows);
                    setDataTableFilter(sortedRows);
                }
                setConfig((prev) => ({
                    ...prev,
                    page: 0,
                    pageSize: 10,
                    sorted: [],
                    total
                }));
            })
            .catch((e) => {
                trackException('API Error: getAllClaimRelatedDocuments (initial load)', {
                    endpoint: 'getAllClaimRelatedDocuments',
                    claimNumber: clmNumber,
                    response: JSON.stringify(e)
                });
                setMSG('serverError');
                setServerError(true);
                setDataTableFilter([]);
                setClaimDocuments([]);
            })
            .finally(() => setIsLoading(false));
    }, [
        shouldFetchFromServer,
        processDocsData,
        sortMergedDates
    ]);

    const customSortFunc = useCallback((firstValue, secondValue, direction) => {
        if (shouldFetchFromServer) {
            if (direction) {
                return -1;
            } else {
                return 1;
            }
        }
        return firstValue?.toString()?.toLocaleLowerCase()?.localeCompare(secondValue?.toString()?.toLocaleLowerCase());
    }, [shouldFetchFromServer]);

    const handlePaginationConfigChange = useCallback((newConfig) => {
        const newSorted = newConfig?.sorted || [];
        const pageSize = newConfig.pageSize || 10;
        const pageNumber = newConfig.page ?? 0;

        if (!shouldFetchFromServer) {
            setConfig((prev) => ({ ...prev, ...newConfig }));
            return;
        }

        getSubmittedDocuments({
            page: pageNumber,
            pageSize,
            sorted: newSorted
        });
    }, [shouldFetchFromServer, getSubmittedDocuments]);


    useEffect(() => {
        document.getElementById('surveryLink').innerHTML = SurveyLink.surveyLink_calimOverview_En('document', LocaleService.getStoredLanguage());
        document.getElementById('feedbackLink').innerHTML = FeedbackLink.feedbackLink_claims('document', LocaleService.getStoredLanguage());
        getSubmittedDocuments();
    }, [claimNumber]);

    const updateReadStatus = (readTrackerResults) => {
        if (!Array.isArray(readTrackerResults) || readTrackerResults.length === 0) {
            return;
        }

        const readMap = {};
        readTrackerResults.forEach((item) => {
            readMap[item.documentId] = item.readFlag === true;
        });

        setClaimDocuments((prevData) => prevData.map((doc) => (readMap[doc.publicID] !== undefined
            ? { ...doc, readFlag: readMap[doc.publicID] }
            : doc)));

        setDataTableFilter((prevData) => prevData.map((doc) => (readMap[doc.publicID] !== undefined
            ? { ...doc, readFlag: readMap[doc.publicID] }
            : doc)));

        if (Array.isArray(UtilService.claimDocuments)) {
            // eslint-disable-next-line operator-linebreak
            UtilService.claimDocuments =
                UtilService.claimDocuments.map((doc) => (readMap[doc.publicID] !== undefined
                    ? { ...doc, readFlag: readMap[doc.publicID] }
                    : doc));
        }
    };

    const is406Error = (error) => {
        const errorMsg = error?.message || error?.toString?.() || '';
        return errorMsg.includes('406');
    };

    const readUnreadTracker = useCallback(async (doc) => {
        try {
            const trackerService = UtilService.getServiceName('claim');

            const params = {
                DocumentId: [doc.publicID],
                ClaimNumber: doc.claimNumber,
                Role: 'pwi'
            };

            if (isIOSSafari()) {
                await new Promise((resolve) => setTimeout(resolve, 800));
            }

            const response = await OSBCClaimService.createOSPCDocumentReadTracker(
                trackerService,
                params
            );

            const results = response || [];
            updateReadStatus(results);
        } catch (e) {
            trackException(
                'API Error: Read Tracker Failure',
                {
                    endpoint: 'createOSPCDocumentReadTracker',
                    documentId: doc?.publicID,
                    claimNumber: doc?.claimNumber,
                    response: JSON.stringify(e)
                }
            );
            console.log("Read-tracker failed, document remains unread");
        }
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getDocumentDetail = useCallback(async (document) => {
        const hasLinkedDoc = !_.isEmpty(document?.coverLettersDetails);

        const tracker = {
            total: hasLinkedDoc ? document.coverLettersDetails.length + 1 : 1,
            mainDocSuccess: 0,
            mainDocFailed: 0,
            coverLetterSuccess: 0,
            coverLetterFailed: 0,
            error406Count: 0,
            otherErrorCount: 0
        };

        let linkedDocError = false;
        let firstError = null;

        // let linkedDocError = false;

        if (!document?.hasFileExtension && !hasLinkedDoc) {
            showDescriptionModal('DOCSCRUBMSG40');
            return false;
        }

        if (
            !document?.hasFileExtension
            && document?.coverLettersDetails?.every(
                (ele) => !ele?.coverLetterHasFileExtension
            )
        ) {
            showDescriptionModal('DOCSCRUBMSG41_1', {
                outcome: 0,
                total: document?.coverLettersDetails?.length + 1
            });
            return false;
        }

        if (multiDownloadInProgressRef.current) {
            // Inform user multi-download in progress
            showQueuedModal(
                <DisplayPopup
                    title={translator(messages.waitforDownloadModalTitle)}
                    closeButtonText={translator(messages.closeText)}
                    onClose={() => {}}
                    customClassName="modalStyle"
                >
                    <p className={styles.PopupSection}>
                        {translator(messages.waitforDownloadModalContent)}
                    </p>
                </DisplayPopup>
            );
            return;
        }
        setIsLoading(true);
        try {
            if (document.publicID.indexOf('bc') > 0) {
                // UtilService.publishGA('Link Click', 'OSPC_ClaimDoc_DescriptionColumnLink', LocaleService.getStoredLanguage());
                const serviceName = UtilService.getServiceName('getBCDocument');
                await OSBCClaimService.getClaimRelatedDocumentDetail(document, 'getBCDocument', showDescriptionModal, readUnreadTracker);
            } else {
                // UtilService.publishGA('Link Click', 'OSPC_ClaimDoc_DescriptionColumnLink', LocaleService.getStoredLanguage());
                const serviceName = UtilService.getServiceName('getClaimDocument');
                if (!document?.hasFileExtension) {
                    tracker.error406Count += 1;
                    tracker.mainDocFailed += 1;
                }
                if (document?.hasFileExtension) {
                    try {
                        await OSBCClaimService.getClaimRelatedDocumentDetail(
                            document,
                            serviceName,
                            showDescriptionModal,
                            readUnreadTracker
                        );

                        tracker.mainDocSuccess += 1;
                    } catch (mainDocError) {
                        tracker.mainDocFailed += 1;

                        if (is406Error(mainDocError)) {
                            tracker.error406Count += 1;
                        } else {
                            tracker.otherErrorCount += 1;
                        }

                        firstError = mainDocError;

                        trackException(
                            'API Error: Main Document Download Failure',
                            {
                                endpoint: 'getClaimDocument',
                                documentId: document?.publicID,
                                claimNumber: document?.claimNumber || claimNumber,
                                response: JSON.stringify(mainDocError)
                            }
                        );

                        const isDocumentNotFound = mainDocError?.message?.toLowerCase() === 'document not found'
                            || mainDocError?.message?.includes('DOCUMENT_NOT_FOUND');

                        // Stop processing cover letters if main document is unpublished
                        if (isDocumentNotFound) {
                            throw mainDocError;
                        }

                        // If main doc failed and no linked doc, stop here
                        if (!hasLinkedDoc) {
                            throw mainDocError;
                        }

                        // If linked docs exist, continue downloading cover letters
                        linkedDocError = true;
                    }
                }

                const isDocumentNotFound = firstError?.message?.toLowerCase() === 'document not found'
                    || firstError?.message?.includes('DOCUMENT_NOT_FOUND');

                if (isDocumentNotFound) {
                    throw firstError;
                }

                if (!_.isEmpty(document.coverLettersDetails)) {
                    if (isIOSSafari()) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const coverLetter of document.coverLettersDetails) {
                            if (!coverLetter?.coverLetterHasFileExtension) {
                                tracker.coverLetterFailed += 1;
                            }
                            if (coverLetter?.coverLetterHasFileExtension) {
                                const payload = {
                                    ...document,
                                    publicID: coverLetter.coverLetterPublicID,
                                    sessionID: coverLetter.coverLetterSessionID
                                };

                                // eslint-disable-next-line no-await-in-loop
                                await new Promise((resolve) => setTimeout(resolve, 800));

                                try {
                                    // eslint-disable-next-line no-await-in-loop
                                    await OSBCClaimService.getClaimRelatedDocumentDetail(
                                        payload,
                                        serviceName,
                                        showDescriptionModal,
                                    );

                                    tracker.coverLetterSuccess += 1;
                                } catch (coverLetterError) {
                                    tracker.coverLetterFailed += 1;

                                    if (is406Error(coverLetterError)) {
                                        tracker.error406Count += 1;
                                    } else {
                                        tracker.otherErrorCount += 1;
                                    }

                                    if (!firstError) {
                                        firstError = coverLetterError;
                                    }

                                    linkedDocError = true;
                                }
                            }
                        }
                    } else {
                        document.coverLettersDetails.forEach((coverLetter) => {
                            if (!coverLetter?.coverLetterHasFileExtension) {
                                tracker.coverLetterFailed += 1;
                                tracker.error406Count += 1;
                            }
                        });
                        // eslint-disable-next-line array-callback-return
                        const coverLetterPromises = document.coverLettersDetails
                            .filter((coverLetter) => coverLetter?.coverLetterHasFileExtension)
                            .map((coverLetter) => {
                                const payload = {
                                    ...document,
                                    publicID: coverLetter.coverLetterPublicID,
                                    sessionID: coverLetter.coverLetterSessionID
                                };

                                return OSBCClaimService.getClaimRelatedDocumentDetail(
                                    payload,
                                    serviceName,
                                    showDescriptionModal
                                );
                            });

                        const results = await Promise.allSettled(coverLetterPromises);

                        results.forEach((result) => {
                            if (result.status === 'fulfilled') {
                                tracker.coverLetterSuccess += 1;
                            } else {
                                tracker.coverLetterFailed += 1;

                                if (is406Error(result.reason)) {
                                    tracker.error406Count += 1;
                                } else {
                                    tracker.otherErrorCount += 1;
                                }

                                if (!firstError) {
                                    firstError = result.reason;
                                }

                                linkedDocError = true;
                            }
                        });
                    }
                }

                const totalSuccess = tracker.mainDocSuccess + tracker.coverLetterSuccess;
                const totalFailed = tracker.mainDocFailed + tracker.coverLetterFailed;

                if (totalFailed > 0) {
                    if (tracker.error406Count > 0) {
                        if (!hasLinkedDoc) {
                            showDescriptionModal('DOCSCRUBMSG40');
                        } else {
                            showDescriptionModal('DOCSCRUBMSG41_1', {
                                outcome: totalSuccess,
                                total: tracker.total
                            });
                        }

                        return false;
                    }

                    if (tracker.otherErrorCount > 0) {
                        if (firstError?.message?.toLowerCase() === 'document not found' || firstError?.message?.includes('DOCUMENT_NOT_FOUND')) {
                            showDescriptionModal('UNPUBLISHEDDOCERR');
                        } else if (hasLinkedDoc) {
                            showDescriptionModal('TWODOCDOWNLOADFAIL');
                        } else {
                            showDescriptionModal('SINGALDOCDOWNLOADFAIL');
                        }

                        return false;
                    }
                }
            }
        } catch (e) {
            trackException(
                'API Error: Get Claim Document Detail Failure',
                {
                    endpoint: document.publicID.indexOf('bc') > 0
                        ? 'getBCDocument'
                        : 'getClaimDocument',
                    documentId: document?.publicID,
                    claimNumber: document?.claimNumber || claimNumber,
                    response: JSON.stringify(e)
                }
            );
            if (!hasLinkedDoc && is406Error(e)) {
                showDescriptionModal('DOCSCRUBMSG40');
                return false;
            }
            if (e.message?.toLowerCase() === 'document not found' || e?.message?.includes('DOCUMENT_NOT_FOUND')) {
                showDescriptionModal('UNPUBLISHEDDOCERR');
            } else if (!_.isEmpty(document.coverLettersDetails)) showDescriptionModal('TWODOCDOWNLOADFAIL');
            else showDescriptionModal('SINGALDOCDOWNLOADFAIL');
        } finally {
            setIsLoading(false);
        }
    });

    const removeActiveClass = useCallback((item) => {
        try {
            if (item.publicID.indexOf('bc') > 0 && item.publicID !== 'none' && item.readIndicator !== true) {
                const serviceNameBC = 'statementProfileInfo';
                const accountNumberBC = item.accountNumber;
                getSubmittedDocuments(accountNumberBC);
            }
        } catch (e) {
            trackException(
                'API Error: Remove Active Class Failure',
                {
                    endpoint: 'statementProfileInfo',
                    documentId: item?.publicID,
                    accountNumber: item?.accountNumber,
                    response: JSON.stringify(e)
                }
            );
            /* eslint-disable-next-line no-console */
            console.log('error in catch block', e);
        }
    }, [getSubmittedDocuments]);


    const handleCheckboxChange = (doc, checked) => {
        if (!doc || !doc.publicID) return;
        setSelectedDocs((prev) => {
            let updatedSelection;
            if (checked) {
                if (prev.some((d) => d.publicID === doc.publicID)) return prev;
                updatedSelection = [...prev, doc];
            } else {
                updatedSelection = prev.filter((d) => d.publicID !== doc.publicID);
            }
            // MSG-18: Show inline warning if exactly 5 selected
            if (updatedSelection.length >= MAX_SELECTION) {
                setMultiDownloadWarningMSG('MSG18');
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmMaxDocSlct_Information', LocaleService.getStoredLanguage());
            } else {
                setMultiDownloadWarningMSG('MSG09'); // Reset message if less than 5
            }

            return updatedSelection;
        });
    };

    // eslint-disable-next-line no-shadow
    const renderCheckboxCell = (props) => {
        const { row, rowData, data } = props || {};
        const rowDataResolved = row?.data || rowData || data || props || {};
        const { publicID, documentDescription } = rowDataResolved || {};
        if (!publicID) return null;
        const isChecked = selectedDocs.some((doc) => doc.publicID === publicID);

        return (
            <input
                type="checkbox"
                tabIndex={0}
                checked={isChecked}
                onChange={({ target: { checked } }) => {
                    handleCheckboxChange(rowDataResolved, checked);
                    setCheckboxAnnounce(
                        `${checked ? 'Checked' : 'Unchecked'} - Select document: ${
                            documentDescription || 'document for download'
                        }`
                    );
                }}
                className={styles.checkboxCell}
            />
        );
    };

    const renderCellDot = (items) => {
        return (
            <div className={`${styles.rowWrapper} ${items.readFlag ? '' : styles.unReadRow}`}>
                <span
                    className={`${styles.readIndicatorDot} ${
                        items.readFlag ? styles.hiddenDot : ''
                    }`}
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                    role="img"
                    // aria-label={translator(messages.ariaLabelBlueDot)}
                    aria-label={!items?.readFlag ? translator(messages.ariaLabelBlueDot) : undefined}
                />
            </div>
        );
    };

    const renderCellDocumentCategory = ((item, index, property) => {
        if (!item.docCategory_Ext && !item.description) {
            return (
                <div className={`${styles.rowWrapper} ${item.readFlag ? '' : styles.unReadRow}`}>
                    {translator({ id: 'not-available' })}
                </div>
            );
        }
        // eslint-disable-next-line no-nested-ternary
        const category = (currentLanguage === 'Fr' ? (item.documentCategoryFr || item.documentCategory) : item.documentCategory);

        return (
            <div className={`${styles.rowWrapper} ${item.readFlag ? '' : styles.unReadRow}`}>
                {/* <span
                    className={`${styles.readIndicatorDot} ${
                        item.readFlag ? styles.hiddenDot : ''
                    }`}
                    role="img"
                    aria-label={!item.readFlag ? translator({id: 'claim-related.indicator'}) : undefined}
                /> */}
                <span className={styles.docText}>
                    {category || translator({ id: 'not-available' })}
                </span>
            </div>
        );
    });

    const renderCellDocumentDescription = useCallback((item) => {
        const description = currentLanguage === 'Fr' ? (item.documentDescriptionFr || item.documentDescription) : item.documentDescription;
        if (!description) {
            return (
                <div className={`${styles.rowWrapper} ${item.readFlag ? '' : styles.unReadRow} ${styles.docDescCellValue}`}>
                    {translator({ id: 'not-available' })}
                </div>
            );
        }
        const ariaLabel = description;
        return (
            <div className={`${styles.rowWrapper} ${item.readFlag ? '' : styles.unReadRow} ${styles.docDescCellValue}`}>
                <Link
                    className={`${styles.desclink}`}
                    onClick={() => {
                        getDocumentDetail(item);
                        removeActiveClass(item);
                    }}
                    aria-label={ariaLabel}
                >
                    {description}
                    {_.isEmpty(item.coverLettersDetails) ? '' : (
                        <span className={styles.claimsFiles}>
                            {" "}(
                            {currentLanguage === 'Fr' ? '2 fichiers' : '2 files'}
                            )
                        </span>
                    )}
                </Link>
            </div>
        );
    }, [getDocumentDetail, removeActiveClass, currentLanguage]);

    const renderCelldocumentSource = ((items, index, property) => {
        const source = currentLanguage === 'Fr' ? (items.channelFr || items.channel) : items.channel;
        if (!source) {
            return (
                <div className={`${styles.rowWrapper} ${items.readFlag ? '' : styles.unReadRow} ${styles.docSourceCellValue}`}>
                    {translator({ id: 'not-available' })}
                </div>
            );
        }
        return (
            <div className={`${styles.rowWrapper} ${items.readFlag ? '' : styles.unReadRow} ${styles.docSourceCellValue}`}>
                {source}
            </div>
        );
    });

    const renderCellSender = ((items, index, property) => {
        const sender = currentLanguage === 'Fr' ? (items.senderFr || items.sender) : items.sender;
        if (!sender) {
            return (
                <div
                    className={`${styles.rowWrapper} ${items.readFlag ? '' : styles.unReadRow} ${styles.docSenderCellValue}`}
                >
                    {translator({ id: 'not-available' })}
                </div>
            );
        }
        const senderAria = sender
            .split(/\r?\n/)
            .map((line) => line.trim())
            .filter(Boolean)
            .join(' ');
        const describedById = `sender-${items.publicID}`;
        return (
            <div
                className={`${styles.rowWrapper} ${items.readFlag ? '' : styles.unReadRow} ${styles.docSenderCellValue}`}
                aria-describedby={describedById}
            >
                <span id={describedById} className="sr-only">
                    {senderAria}
                </span>
                <div
                    onMouseEnter={(e) => e.currentTarget.removeAttribute('aria-hidden')}
                    onMouseLeave={(e) => e.currentTarget.setAttribute('aria-hidden', 'true')}
                    aria-hidden="true"
                >
                    {
                        (
                            (sender || '').replace(/\\n/g, '\n').includes('\n')
                                ? (sender || '').replace(/\\n/g, '\n').split(/\r?\n/)
                                : (sender || '').split(/(?=Sent to|CC |Copy |Envoyé à|Envoyé au|prestataire|Copie conforme)/i)
                        )
                            .map((line, i) => {
                                let formattedLine = line;

                                if (currentLanguage === 'Fr') {
                                    formattedLine = formattedLine
                                        .replace(/Envoyé au\s+/i, 'Envoyé au\n')
                                        .replace(/prestataire\s+/i, 'prestataire\n')
                                        .replace(/Envoyé à\s+/i, 'Envoyé à\n')
                                        .replace(/Copie conforme\s+/i, 'Copie conforme\n')
                                        .replace(/à une autre\s+/i, 'à une autre\n')
                                        .replace(/partie du lieu de\s+/i, 'partie du lieu de\n');
                                }

                                return formattedLine
                                    .split('\n')
                                    .map((subLine, subIndex) => (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <span key={`${i}-${subIndex}`} style={{ display: 'block' }}>
                                            {subLine.trim()}
                                        </span>
                                    ));
                            })
                    }
                </div>
            </div>
        );
    });

    const renderCellDateReceived = useCallback(
        (item) => {
            const dateValue = item[`dateReceived${currentLanguage || 'En'}`];
            return (
                <div className={`${styles.rowWrapper} ${item.readFlag ? '' : styles.unReadRow} ${styles.docDatePostedCellValue}`}>
                    {dateValue || translator({ id: 'not-available' })}
                </div>
            );
        },
        [translator, currentLanguage]
    );

    const handleSearchValueChange = useCallback((keyword) => {
        setShowBasicSearchLimitWarning(false);
        setCallLoadData(false);
        setSearchFilter(keyword);
        setIsShowDefaultViewMessage(false);
    }, []);


    const getDefaultViewMessage = useCallback(() => {
        switch (MSG) {
            case 'MSG10':
                return (
                    <span aria-live="assertive">
                        {translator(messages.MSG10)}
                    </span>
                );
            case 'MSG11':
                return (
                    <span aria-live="assertive">
                        {translator(messages.MSG11)}
                    </span>
                );
            default:
                return null;
        }
    }, [MSG, translator]);

    const resetSearchErrors = useCallback((field = undefined) => {
        if (field && error[field]) {
            setError((prevError) => {
                const newError = { ...prevError };
                if (newError[field]) {
                    delete newError[field];
                }
                return newError;
            });
        } else {
            setError({});
        }
    }, [error]);

    // This function validates the search filters for date fields.
    const validateSearchResult = useCallback(() => {
        const err = {};
        const isFutureInputFromDate = selectedFromDate?.rawFromDate === undefined
            ? true
            : UtilService.isValidYYYYMMDDNew(selectedFromDate.rawFromDate);
        if (selectedFromDate.rawFromDate && !UtilService.isValidYYYYMMDDNew(selectedFromDate.rawFromDate)) {
            const isFutureFromDate = UtilService.isFutureYYYYMMDD(selectedFromDate.rawFromDate);
            err.fromDate = isFutureFromDate
                ? translator({ id: 'document-history.error.MSG28' }) // future date
                : translator({ id: 'claim-related.invalidFromDateError' }); // other invalid cases
            if (isFutureFromDate) {
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmFutureDate_Error', LocaleService.getStoredLanguage());
            } else {
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmIncorrDtFrmt_Error', LocaleService.getStoredLanguage());
            }
        } else {
            resetSearchErrors('fromDate');
        }

        if (selectedToDate.rawToDate && !UtilService.isValidYYYYMMDDNew(selectedToDate.rawToDate)) {
            const isFutureToDate = UtilService.isFutureYYYYMMDD(selectedToDate.rawToDate);
            err.toDate = isFutureToDate
                ? translator({ id: 'document-history.error.MSG28' })
                : translator({ id: 'claim-related.invalidToDateError' });
            if (isFutureToDate) {
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmFutureDate_Error', LocaleService.getStoredLanguage());
            } else {
                UtilService.publishGA('Error', 'VD_OSPC_ViewClmIncorrDtFrmt_Error', LocaleService.getStoredLanguage());
            }
        } else {
            resetSearchErrors('toDate');
        }

        if (isFutureInputFromDate && (_.isUndefined(selectedToDate.rawToDate) || UtilService.isValidYYYYMMDDNew(selectedToDate.rawToDate)) && selectedFromDate.fromDate && selectedToDate.toDate && selectedFromDate.fromDate > selectedToDate.toDate) {
            err.fromDate = translator({ id: 'claim-related.earlierFromDateError' });
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmFrmDtLtrToDt_Error', LocaleService.getStoredLanguage());
        } else {
            resetSearchErrors('fromDate');
        }

        if (
            !selectedFromDate.fromDate
            && !selectedToDate.toDate
            && !searchFilters.documentCategory
            && !searchFilters.documentDescription
            && !searchFilters.documentSource
            && !searchFilters.sender
            && !err.fromDate
            && !err.toDate
        ) {
            err.commonError = translator({ id: 'claim-related.datatable.MSG10' });
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmSrchCriteriaEmpty_Error', LocaleService.getStoredLanguage());
        } else {
            resetSearchErrors('commonError');
        }

        // Key change: force NVDA to re-announce the same error on every Search click
        const isValid = _.isEmpty(err);

        if (!isValid) {
            // 1) clear first (forces DOM/text change)
            setError({});

            // 2) set again next tick
            window.setTimeout(() => {
                setError(err);
            }, 50);

            return false;
        }

        // When valid, keep normal behavior
        setError(err);
        return true;
    }, [
        selectedFromDate.rawFromDate,
        selectedFromDate.fromDate,
        selectedToDate.rawToDate,
        selectedToDate.toDate,
        searchFilters.documentCategory,
        searchFilters.documentDescription,
        searchFilters.documentSource,
        searchFilters.sender,
        translator,
        resetSearchErrors
    ]);


    const resetDefaultFn = useCallback((evt, isFromAdvSearch = false) => {
        const dropdownPlaceholder = translator(messages.dropdownPlaceholder);
        const isKeywordEmpty = !searchFilter || searchFilter.trim().length === 0;
        const isDropdownDefault = dropdownValues === dropdownPlaceholder;
        const isAdvSearchEmpty = !searchFilters.documentCategory
            && !searchFilters.documentDescription
            && !searchFilters.documentSource
            && !searchFilters.sender
            && !selectedFromDate.fromDate
            && !selectedToDate.toDate
            && !selectedFromDate.rawFromDate
            && !selectedToDate.rawToDate;

        const hasBasicToReset = !isKeywordEmpty || !isDropdownDefault;
        const hasAdvToReset = !isAdvSearchEmpty;
        const hadAppliedSearch = hasAppliedFilters;

        setSelectedDocs([]);
        setMultiDownloadWarningMSG('');

        if (!hadAppliedSearch) {
            if (isFromAdvSearch) {
                if (!hasAdvToReset) {
                    window.setTimeout(() => {
                        setError({ commonError: translator(messages.MSG11) });
                    }, 50);
                    UtilService.publishGA('Error', 'VD_OSPC_ViewClmNoFltrAppld_Error', LocaleService.getStoredLanguage());
                    return;
                }
                setSearchFilters({
                    documentCategory: '',
                    documentDescription: '',
                    documentSource: '',
                    sender: ''
                });

                setSelectedFromDate({
                    rawFromDate: '',
                    fromDate: null
                });

                setSelectedToDate({
                    rawToDate: '',
                    toDate: null
                });
            } else {
                if (isKeywordEmpty && !isDropdownDefault) {
                    setDropdownValues(dropdownPlaceholder);
                    setSearchFilter('');
                    setError({});
                    setIsShowDefaultViewMessage(true);
                    setMSG('');
                    window.setTimeout(() => setMSG('MSG11'), 50);
                    return;
                }

                if (!hasBasicToReset) {
                    setError({});
                    setIsShowDefaultViewMessage(true);
                    setMSG('');
                    window.setTimeout(() => setMSG('MSG11'), 50);
                    return;
                }

                setDropdownValues(dropdownPlaceholder);
                setSearchFilter('');

                setSearchFilters({
                    documentCategory: '',
                    documentDescription: '',
                    documentSource: '',
                    sender: ''
                });

                setSelectedFromDate({
                    rawFromDate: '',
                    fromDate: null
                });

                setSelectedToDate({
                    rawToDate: '',
                    toDate: null
                });
            }
            setIsSearching(false);
            setIsShowDefaultViewMessage(false);
            setMSG('');
            setError({});
            setShowBasicSearchLimitWarning(false);
            return;
        }
        setIsSearching(false);
        setHasAppliedFilters(false);
        setIsShowDefaultViewMessage(false);
        setMSG('');
        setError({});
        setShowBasicSearchLimitWarning(false);

        setConfig((oldConfig) => ({
            ...oldConfig,
            page: 0,
            pageSize: 10,
            sorted: []
        }));
        serverQueryRef.current.documentSearchCriteria = null;
        serverQueryRef.current.orderBy = null;
        serverQueryRef.current.orderByDescending = null;
        serverSortRef.current.field = null;
        serverSortRef.current.desc = false;
        lastSortRef.current = [];

        setDropdownValues(dropdownPlaceholder);
        setSearchFilter('');

        setSearchFilters({
            documentCategory: '',
            documentDescription: '',
            documentSource: '',
            sender: ''
        });
        setSelectedFromDate({
            rawFromDate: '',
            fromDate: null
        });

        setSelectedToDate({
            rawToDate: '',
            toDate: null
        });

        const clmNumber = UtilService.fetchClaimNumber();
        const serviceName = UtilService.getServiceName('claim');

        setIsLoading(true);

        OSBCClaimService.getAllClaimRelatedDocuments(
            clmNumber,
            serviceName,
            {},
            {
                limit: 10,
                offset: 0,
                pageNumber: 0,
                documentSearchCriteria: null,
                orderBy: null,
                orderByDescending: null
            }
        )
            .then((resp) => {
                const result = unwrapResult(resp);
                const rows = processDocsData(result?.claimDocuments || []);
                const total = typeof result?.maxNumberOfResults === 'number'
                    ? result.maxNumberOfResults
                    : rows.length;

                setTotalRecordCount(total);

                const serverMode = computeServerMode(total, rows.length);
                setShouldFetchFromServer(serverMode);

                setDataTableFilter(
                    serverMode
                        ? buildServerPagedArray(rows, 0, total)
                        : rows
                );

                setConfig((prev) => ({
                    ...prev,
                    page: 0,
                    pageSize: 10,
                    sorted: [],
                    total
                }));
            })
            .catch(() => {
                setMSG('serverError');
                setServerError(true);
                setDataTableFilter([]);
            })
            .finally(() => setIsLoading(false));
    }, [
        searchFilter,
        dropdownValues,
        searchFilters,
        selectedFromDate,
        selectedToDate,
        translator,
        processDocsData,
        hasAppliedFilters
    ]);

    const getClaimMessages = useCallback(() => {
        switch (MSG) {
            case 'serverError':
                return translator(messages.datatableServerError);
            case 'noDataFoundinAdvanceSearch':
                return translator(messages.noDataFoundinAdvanceSearch);
            case 'MSG10':
                return translator(messages.MSG10);
            case 'MSG11':
                return translator(messages.MSG11);
            case 'MSG17':
                return translator(messages.MSG17);
            default:
                return translator(messages.datatableNdDataText);
        }
    }, [translator, MSG]);

    const filterClaimData = useCallback(() => {
        const keyword = (searchFilter || '').trim();
        if (!keyword) {
            setIsShowDefaultViewMessage(true);
            setMSG({});
            window.setTimeout(() => setMSG('MSG10'), 50);
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmSrchCriteriaEmpty_Error', LocaleService.getStoredLanguage());
            return;
        }

        setIsShowDefaultViewMessage(false);
        setShowBasicSearchLimitWarning(false);

        const normalizedDropdown = _.toLower(dropdownValues);
        if (normalizedDropdown === _.toLower(translator(messages.dropDownDateReceived))) {
            UtilService.publishGA('Button Click', 'VD_OSPC_ViewClmRelDocDatePosted_Action', LocaleService.getStoredLanguage());
        } else if (normalizedDropdown === _.toLower(translator(messages.dropDownDocumentCategory))) {
            UtilService.publishGA('Button Click', 'VD_OSPC_ViewClmRelDocDocCat_Action', LocaleService.getStoredLanguage());
        } else if (normalizedDropdown === _.toLower(translator(messages.dropDownDocumentDescription))) {
            UtilService.publishGA('Button Click', 'VD_OSPC_ViewClmRelDocDocDescr_Action', LocaleService.getStoredLanguage());
        } else {
            UtilService.publishGA('Button Click', 'VD_OSPC_ViewClmRelDocSearchAll_Action', LocaleService.getStoredLanguage());
        }

        if (shouldFetchFromServer || _.isEmpty(claimDocuments)) {
            const clmNumber = UtilService.fetchClaimNumber();
            const serviceName = UtilService.getServiceName('claim');

            const criteria = buildBasicSearchCriteria({
                dropdownValues,
                searchFilter: keyword,
                lang,
                translator
            });

            if (!criteria) return;

            serverQueryRef.current.documentSearchCriteria = criteria;

            serverQueryRef.current.orderBy = null;
            serverQueryRef.current.orderByDescending = null;
            serverSortRef.current.field = null;
            serverSortRef.current.desc = false;
            lastSortRef.current = [];

            setIsLoading(true);

            OSBCClaimService.getAllClaimRelatedDocuments(
                clmNumber,
                serviceName,
                {},
                {
                    limit: 10,
                    offset: 0,
                    pageNumber: 0,
                    orderBy: null,
                    orderByDescending: null,
                    documentSearchCriteria: criteria
                }
            )
                .then((resp) => {
                    const result = unwrapResult(resp);
                    const rows = processDocsData(result?.claimDocuments || []);
                    const total = (typeof result?.maxNumberOfResults === 'number')
                        ? result.maxNumberOfResults
                        : rows.length;

                    setTotalRecordCount(total);

                    setDataTableFilter(buildServerPagedArray(rows, 0, total));

                    const serverMode = computeServerMode(total, rows.length);
                    setShouldFetchFromServer(serverMode);

                    setConfig((prev) => ({
                        ...prev,
                        page: 0,
                        pageSize: 10,
                        sorted: [],
                        total
                    }));
                    setHasAppliedFilters(true);
                    setSelectedDocs([]);
                    setMultiDownloadWarningMSG('');
                    setIsSearching(true);
                    setMSG(rows.length ? '' : 'MSG17');
                })
                .catch(() => {
                    setMSG('tableMsgErr2');
                    setDataTableFilter([]);
                })
                .finally(() => setIsLoading(false));

            return;
        }
        const normalizedFilter = _.toLower(
            (keyword || '')
                .replace(/(\r\n|\n|\r)/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
        );
        const isFr = currentLanguage === 'Fr';

        const labelDocCategory = _.toLower(translator(messages.dropDownDocumentCategory));
        const labelDocDescription = _.toLower(translator(messages.dropDownDocumentDescription));
        const labelDocSource = _.toLower(translator(messages.dropDownDocumentSource));
        const labelDocSender = _.toLower(translator(messages.dropDownDocumentSender));
        const labelDateReceived = _.toLower(translator(messages.dropDownDateReceived));

        const result = _.filter(claimDocuments, (document) => {
            const senderTrim = (document[`sender${currentLanguage}`] || '')
                .replace(/\\n/g, ' ')
                .replace(/(\r\n|\n|\r)/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            const filesCount = document?.coverLettersDetails?.length || 0;
            const baseDesc = document[`documentDescription${currentLanguage}`] || document.documentDescription || '';
            const desc = baseDesc + (filesCount > 0 ? `\n(${isFr ? '2 fichiers' : '2 files'})` : '');

            const docCat = document[`documentCategory${currentLanguage}`] || '';
            const docSrc = document[`channel${currentLanguage}`] || '';
            const dateStr = document[`dateReceived${currentLanguage || 'En'}`] || '';

            if (normalizedDropdown === labelDocCategory) return _.toLower(docCat).includes(normalizedFilter);
            if (normalizedDropdown === labelDocDescription) return _.toLower(desc).includes(normalizedFilter);
            if (normalizedDropdown === labelDocSource) return _.toLower(docSrc).includes(normalizedFilter);
            if (normalizedDropdown === labelDocSender) return _.toLower(senderTrim).includes(normalizedFilter);
            if (normalizedDropdown === labelDateReceived) return _.toLower(dateStr).includes(normalizedFilter);

            return Object.values({
                documentCategory: docCat,
                description: desc,
                documentSource: docSrc,
                sender: senderTrim,
                dateReceived: dateStr
            }).some((v) => String(v || '').toLowerCase().includes(normalizedFilter));
        });

        if (!result || result.length === 0) {
            setMSG('MSG17');
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmNoMatchFound_Information', LocaleService.getStoredLanguage());
        } else {
            setMSG('');
        }

        setConfig((prev) => ({
            ...prev,
            page: 0,
            pageSize: 10,
            sorted: [],
            total: result.length
        }));
        setHasAppliedFilters(true);
        setSelectedDocs([]);
        setMultiDownloadWarningMSG('');
        setIsSearching(true);
        setDataTableFilter(result || []);
    }, [
        shouldFetchFromServer,
        searchFilter,
        dropdownValues,
        claimDocuments,
        lang,
        translator,
        currentLanguage,
        processDocsData
    ]);

    // This function filters the claim documents based on the search filters including date range and other fields. It first validates the search filters and if valid, it applies the filters to the claim documents and updates the data table. If no results are found, it sets an appropriate message.
    const filterSubmittedDocuments = useCallback(() => {
        UtilService.publishGA('Button Click', 'VD_OSPC_ViewClmRelDocAdvSearch_Action', LocaleService.getStoredLanguage());
        if (!validateSearchResult()) return;
        const {
            documentCategory, documentDescription, documentSource, sender
        } = searchFilters;

        setSelectedDocs([]);
        setMultiDownloadWarningMSG('');
        setIsShowDefaultViewMessage(false);

        if (shouldFetchFromServer || _.isEmpty(claimDocuments)) {
            const clmNumber = UtilService.fetchClaimNumber();
            const serviceName = UtilService.getServiceName('claim');

            const payload = {
                limit: 10,
                offset: 0,
                pageNumber: 0,
                orderBy: null,
                orderByDescending: null,
                documentSearchCriteria: {
                    docDescription: lang.startsWith('en') ? documentDescription?.trim() || null : null,
                    docDescriptionFr: lang.startsWith('fr') ? documentDescription?.trim() || null : null,

                    sender: lang.startsWith('en') ? sender?.trim() || null : null,
                    senderFr: lang.startsWith('fr') ? sender?.trim() || null : null,

                    docCategory: documentCategory
                        ? UtilService.fetchDataFromList(DOCUMENT_CATEGORY, documentCategory, lang)?.code
                        : null,

                    channel: documentSource
                        ? UtilService.fetchDataFromList(DOCUMENT_SOURCE, documentSource, lang)?.code
                        : null,

                    datePostedFrom: selectedFromDate.fromDate ? formatLocalDate(selectedFromDate.fromDate) : null,
                    datePostedTo: selectedToDate.toDate ? formatLocalDate(selectedToDate.toDate) : null
                }
            };

            serverQueryRef.current.documentSearchCriteria = payload.documentSearchCriteria;
            serverQueryRef.current.orderBy = null;
            serverQueryRef.current.orderByDescending = null;
            serverSortRef.current.field = null;
            serverSortRef.current.desc = false;
            lastSortRef.current = [];

            setIsLoading(true);
            OSBCClaimService.getAllClaimRelatedDocuments(
                clmNumber,
                serviceName,
                {},
                payload
            )
                .then((resp) => {
                    const result = unwrapResult(resp);
                    const rows = processDocsData(result?.claimDocuments || []);
                    const total = (typeof result?.maxNumberOfResults === 'number')
                        ? result.maxNumberOfResults
                        : rows.length;

                    setTotalRecordCount(total);
                    setDataTableFilter(buildServerPagedArray(rows, 0, total));
                    const serverMode = computeServerMode(total, rows.length);
                    setShouldFetchFromServer(serverMode);
                    setConfig((prev) => ({
                        ...prev,
                        page: 0,
                        pageSize: 10,
                        sorted: [],
                        total
                    }));
                    setHasAppliedFilters(true);
                    setIsSearching(true);
                    setMSG(rows.length ? '' : 'noDataFoundinAdvanceSearch');
                })
                .catch(() => {
                    setMSG('tableMsgErr2');
                    setDataTableFilter([]);
                })
                .finally(() => setIsLoading(false));

            return;
        }

        const baseData = claimDocuments || [];
        const result = _.filter(baseData, (document) => {
            const senderTrim = (document[`sender${currentLanguage}`] || '')
                .replace(/\\n/g, ' ')
                .replace(/(\r\n|\n|\r)/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            const checkDocumentCategory = !documentCategory
                || UtilService.fetchLocalizedValue(document?.documentCategory, document?.documentCategoryFr, lang)
                    .toLowerCase() === UtilService.fetchDataFromList(DOCUMENT_CATEGORY, documentCategory, lang).name.toLowerCase();
            const normalizedInput = documentDescription.replace(/\s*\(/g, ' (').replace(/\s+/g, ' ').trim();
            const checkDocumentDescription = !documentDescription
                || UtilService.fetchLocalizedValue(
                    `${document.documentDescription} ${(document.coverLettersDetails?.length || 0) > 0 ? '(2 files)' : ''}`,
                    `${document.documentDescriptionFr} ${(document.coverLettersDetails?.length || 0) > 0 ? '(2 fichiers)' : ''}`,
                    lang
                ).toLowerCase().includes(normalizedInput.toLowerCase());

            const checkDocumentSource = !documentSource
                || UtilService.fetchLocalizedValue(document?.channel, document?.channelFr, lang)
                    .toLowerCase() === UtilService.fetchDataFromList(DOCUMENT_SOURCE, documentSource, lang).name.toLowerCase();

            const normalizeInput = (sender || '')
                .replace(/(\r\n|\n|\r)/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();

            const checkSender = !sender || senderTrim.toLowerCase().includes(normalizeInput.toLowerCase());

            const checkDate = UtilService.isWithinDateRange(document.dateReceived, selectedFromDate.fromDate, selectedToDate.toDate);

            return checkDocumentCategory && checkDocumentDescription && checkDocumentSource && checkSender && checkDate;
        });

        setDataTableFilter(result);
        setSelectedDocs([]);
        setMultiDownloadWarningMSG('');
        setMSG(result?.length ? '' : 'noDataFoundinAdvanceSearch');
        setIsSearching(true);
        setHasAppliedFilters(true);
        setConfig((prev) => ({
            ...prev,
            page: 0,
            pageSize: 10,
            sorted: [],
            total: result.length
        }));
    }, [
        shouldFetchFromServer,
        validateSearchResult,
        searchFilters,
        claimDocuments,
        lang,
        DOCUMENT_CATEGORY,
        DOCUMENT_SOURCE,
        selectedFromDate.fromDate,
        selectedToDate.toDate,
        currentLanguage,
        processDocsData
    ]);

    const formatDocumentIdsForDownload = (documentId) => {
        if (!documentId) return [];

        const ids = Array.isArray(documentId) ? documentId : [documentId];
        return ids.map((id) => id.replace(/\s+/g, ''));
    };

    const showDownloadCompletionModal = (successFiles, total, multiPop) => {
        let title;
        let msg;
        switch (multiPop) {
            case 'SCRUB_ERROR_MODEL':
                title = translator({ id: 'invalid-document-error-title-msg-41' });
                msg = translator({ id: 'invalid-document-error-description-msg-41' }, {outcome: successFiles, total: total});
                break;
            default:
                title = translator(messages.multiDownloadModalTitle);
                msg = translator(messages.noofDocumentsDownloadedmsg);
        }
        const downloadMessage = () => (
            LocaleService.getStoredLanguage() === 'fr'
                ? `${successFiles} ${translator({ id: 'claim-related.noofDocumentsDownloadedmsg' })} ${total} ${translator({ id: 'claim-related.noofDocumentsDownloadedmsg1' })}`
                : `${successFiles}/${total} ${msg}`
        );
        showQueuedModal(
            <DisplayPopup
                title={title}
                closeButtonText={translator(messages.closeText)}
                onClose={() => {}}
                customClassName="modalStyle"
            >
                <p className={styles.PopupSection}>
                    {multiPop === 'SCRUB_ERROR_MODEL' && currentLanguage === 'Fr'
                        ? msg
                        : downloadMessage()}
                </p>
            </DisplayPopup>
        );
        UtilService.publishGA('Error', 'VD_OSPC_ViewClmDocDwnldFail_Error', LocaleService.getStoredLanguage());
    };

    const updateReadStatusAfterDownload = () => {
        const documentIds = Array.from(successfulDocumentIdsRef.current);

        if (documentIds.length === 0) return;

        const serviceName = UtilService.getServiceName('claim');
        const params = {
            DocumentId: documentIds,
            ClaimNumber: UtilService.fetchClaimNumber(),
            Role: 'pwi'
        };
        OSBCClaimService.createOSPCDocumentReadTracker(serviceName, params)
            .then((response) => {
                const results = response || [];
                updateReadStatus(results);
            })
            .catch((e) => {
                trackException(
                    'API Error: Multi Download Read Tracker Failure',
                    {
                        endpoint: 'createOSPCDocumentReadTracker',
                        documentIds,
                        claimNumber: UtilService.fetchClaimNumber(),
                        response: JSON.stringify(e)
                    }
                );
                console.log("Read-tracker api failed, document remains unread");
            });
    };

    const getTotalFileCount = (document) => {
        const coverLetterCount = document?.coverLettersDetails?.length || 0;
        return coverLetterCount + 1;
    };

    const getDocumentDetailWithTracking = (
        document,
        onSuccess,
        onFailure,
        onDocScrubFailure,
        onComplete
    ) => {
        let completed = false;

        const groupTracker = {
            mainSuccess: false,
            mainFailed: false,
            coverLetterFailed: false,
            scrubFailed: false,
            otherFailed: false
        };

        const markCompleteOnce = () => {
            if (!completed) {
                completed = true;
                onComplete();
            }
        };

        const serviceName = document.publicID.indexOf('bc') > 0
            ? 'getBCDocument'
            : UtilService.getServiceName('getClaimDocument');

        const trackDownloadFailure = (error, downloadType, publicID) => {
            trackException(
                `API Error: Multi Download ${downloadType} Failure`,
                {
                    endpoint: document.publicID.indexOf('bc') > 0
                        ? 'getBCDocument'
                        : 'getClaimDocument',
                    documentId: publicID,
                    claimNumber: document?.claimNumber,
                    response: JSON.stringify(error)
                }
            );
        };

        const isDocumentNotFoundError = (error) => {
            const message = typeof error === 'string'
                ? error
                : error?.message || JSON.stringify(error || '');

            return message?.toLowerCase() === 'document not found'
                || message.includes('DOCUMENT_NOT_FOUND');
        };

        const downloadFile = async (payload, hasFileExtension, downloadType) => {
            let failureAlreadyCounted = false;
            let failedByCallback = false;
            let scrubError = false;
            let documentNotFoundError = false;

            const failureCallback = (errorMessage = '') => {
                if (!isPageActiveRef.current || failureAlreadyCounted) {
                    return;
                }

                failureAlreadyCounted = true;
                failedByCallback = true;

                trackDownloadFailure(errorMessage, downloadType, payload?.publicID);

                if (is406Error(errorMessage)) {
                    scrubError = true;
                }
                if (isDocumentNotFoundError(errorMessage)) {
                    documentNotFoundError = true;
                }
            };

            // No API call if file extension flag is false
            // Treat as 406/scrub error
            if (!hasFileExtension) {
                return {
                    success: false,
                    scrub: true,
                    documentNotFound: false
                };
            }

            try {
                const promise = OSBCClaimService.getMultiDownloadClaimRelatedDocumentDetail(
                    payload,
                    serviceName,
                    failureCallback
                );

                await Promise.resolve(promise);

                if (failedByCallback) {
                    return {
                        success: false,
                        scrub: scrubError,
                        documentNotFound: documentNotFoundError
                    };
                }

                return {
                    success: true,
                    scrub: false,
                    documentNotFound: false
                };
            } catch (e) {
                if (!failureAlreadyCounted) {
                    trackDownloadFailure(e, downloadType, payload?.publicID);
                }

                return {
                    success: false,
                    scrub: is406Error(e),
                    documentNotFound: isDocumentNotFoundError(e)
                };
            }
        };

        Promise.resolve()
            .then(async () => {
                const mainResult = await downloadFile(
                    document,
                    document?.hasFileExtension,
                    'MAIN_DOC_DOWNLOAD'
                );

                if (mainResult.success) {
                    groupTracker.mainSuccess = true;
                } else {
                    groupTracker.mainFailed = true;

                    if (mainResult.scrub) {
                        groupTracker.scrubFailed = true;
                    } else {
                        groupTracker.otherFailed = true;
                    }
                }
                // Stop cover letter download if main document is unpublished/not found
                if (mainResult.documentNotFound) {
                    onFailure();
                    return;
                }

                if (!_.isEmpty(document?.coverLettersDetails)) {
                    const coverPromises = document.coverLettersDetails.map((coverLetter) => {
                        const payload = {
                            ...document,
                            publicID: coverLetter.coverLetterPublicID,
                            sessionID: coverLetter.coverLetterSessionID
                        };

                        return downloadFile(
                            payload,
                            coverLetter?.coverLetterHasFileExtension,
                            'COVER_LETTER_DOWNLOAD'
                        );
                    });

                    const coverResults = await Promise.allSettled(coverPromises);

                    coverResults.forEach((result) => {
                        const coverResult = result?.value;

                        if (!coverResult?.success) {
                            groupTracker.coverLetterFailed = true;

                            if (coverResult?.scrub) {
                                groupTracker.scrubFailed = true;
                            } else {
                                groupTracker.otherFailed = true;
                            }
                        }
                    });
                }

                const isGroupSuccess = groupTracker.mainSuccess
                    && !groupTracker.mainFailed
                    && !groupTracker.coverLetterFailed;

                if (isGroupSuccess) {
                    onSuccess();

                    const ids = formatDocumentIdsForDownload(document.publicID);
                    ids.forEach((id) => successfulDocumentIdsRef.current.add(id));

                    return;
                }

                if (groupTracker.scrubFailed) {
                    onDocScrubFailure();
                } else {
                    onFailure();
                }
            })
            .catch((e) => {
                trackException(
                    'API Error: Multi Download Unexpected Failure',
                    {
                        endpoint: document.publicID.indexOf('bc') > 0
                            ? 'getBCDocument'
                            : 'getClaimDocument',
                        documentId: document?.publicID,
                        claimNumber: document?.claimNumber,
                        response: JSON.stringify(e)
                    }
                );

                if (is406Error(e)) {
                    onDocScrubFailure();
                } else {
                    onFailure();
                }
            })
            .finally(() => {
                markCompleteOnce();
            });
    };

    const downloadMultipleDocuments = (selectedDocs) => {
        successfulDocumentIdsRef.current.clear();

        const totalCount = selectedDocs.length;

        let successCount = 0;
        let failedCount = 0;
        let completedCount = 0;
        let docScrubFailedCount = 0;

        const onSuccess = () => {
            successCount += 1;
        };

        const onFailure = () => {
            failedCount += 1;
        };

        const onDocScrubFailure = () => {
            docScrubFailedCount += 1;
        };

        const onComplete = () => {
            completedCount += 1;

            console.log(
                `Completed: ${completedCount}, Success: ${successCount}, Failed: ${failedCount}, Scrub Failed: ${docScrubFailedCount}`
            );

            const successTotalCount = successCount;

            if (completedCount === selectedDocs.length) {
                if (successTotalCount > 0) {
                    updateReadStatusAfterDownload();
                }

                if (!isPageActiveRef.current) {
                    multiDownloadInProgressRef.current = false;
                    return;
                }

                if (failedCount > 0 || docScrubFailedCount > 0) {
                    let multiPop;

                    if (docScrubFailedCount > 0) {
                        multiPop = 'SCRUB_ERROR_MODEL';
                    } else {
                        multiPop = 'DEFAULT_ERROR_MODEL';
                    }

                    showDownloadCompletionModal(successTotalCount, totalCount, multiPop);
                }

                setIsMultiDownloadInProgress(false);
                multiDownloadInProgressRef.current = false;
            }
        };

        selectedDocs.forEach((doc) => {
            getDocumentDetailWithTracking(
                doc,
                onSuccess,
                onFailure,
                onDocScrubFailure,
                onComplete
            );
        });
    };

    const handleDownloadSelected = () => {
        if (selectedDocs.length === 0) {
            setMultiDownloadWarningMSG('MSG25');
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmDocNoDocSlct_Error', LocaleService.getStoredLanguage());
            return;
        }

        if (multiDownloadInProgressRef.current) {
            // Inform user multi-download in progress
            showQueuedModal(
                <DisplayPopup
                    title={translator(messages.waitforDownloadModalTitle)}
                    closeButtonText={translator(messages.closeText)}
                    onClose={() => {}}
                    customClassName="modalStyle"
                >
                    <p className={styles.PopupSection}>
                        {translator(messages.waitforDownloadModalContent)}
                    </p>
                </DisplayPopup>
            );
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmMltDocDwnldProgrs_Error', LocaleService.getStoredLanguage());
            return;
        }

        if (selectedDocs.length > MAX_SELECTION) {
            // More than 5 documents selected
            showQueuedModal(
                <DisplayPopup
                    title={translator(messages.tooManyFilesError)}
                    closeButtonText={translator(messages.closeText)}
                    name="Too Many Files"
                    customClassName="modalStyle"
                >
                    <p className={styles.PopupSection}>
                        {translator(messages.MSG19)}
                    </p>
                </DisplayPopup>
            );
            UtilService.publishGA('Error', 'VD_OSPC_ViewClmMaxDocSlctExcd_Error', LocaleService.getStoredLanguage());
            return;
        }

        setIsMultiDownloadInProgress(true); // mark multi-download started
        multiDownloadInProgressRef.current = true;

        setSelectedDocs([]);
        setMultiDownloadWarningMSG('');
        UtilService.publishGA('Error', 'VD_OSPC_ViewClmMltlDocDwnld_Information', LocaleService.getStoredLanguage());
        downloadMultipleDocuments(selectedDocs);
    };

    // handleFromDateChange, handleFromRawChange, handleToDateChange, handleToRawChange are handling both raw and actual date values to provide better user experience in date input fields. The raw value is used to validate the date format as user types, while the actual date value is used for filtering the documents based on date range.
    const handleFromDateChange = useCallback((date) => {
        if (!date) {
            resetSearchErrors('fromDate');
            setSelectedFromDate({ rawFromDate: '', fromDate: null });
            return;
        }

        setSelectedFromDate((prevState) => ({
            ...prevState,
            fromDate: date
        }));
    }, [resetSearchErrors]);

    const handleFromRawChange = useCallback((raw) => {
        if (!raw.target?.value) {
            resetSearchErrors('fromDate');
            setSelectedFromDate({ rawFromDate: '', fromDate: null });
        }
        const data = { ...selectedFromDate, rawFromDate: raw?.target?.value };
        setSelectedFromDate(data);
    }, [resetSearchErrors, selectedFromDate]);

    const handleToDateChange = useCallback((date) => {
        if (!date) {
            resetSearchErrors('toDate');
            setSelectedToDate({ rawToDate: '', toDate: null });
            return;
        }

        setSelectedToDate((prevState) => ({
            ...prevState,
            toDate: date
        }));
    }, [resetSearchErrors]);

    const handleToRawChange = useCallback((raw) => {
        if (!raw.target?.value) {
            resetSearchErrors('toDate');
            setSelectedToDate({ rawToDate: '', toDate: null });
        }
        const data = { ...selectedToDate, rawToDate: raw?.target?.value };
        setSelectedToDate(data);
    }, [resetSearchErrors, selectedToDate]);

    const handleSearchFieldValueChange = ({ fieldName }, value) => {
        setSearchFilters((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }));
    };

    const showDateSelectionModal = () => {
        ModalNextProvider.showModal(
            <DisplayPopup title={translator(messages.dateTooltipHeading)} closeButtonText={translator({ id: 'platform.modal.ModalService.Close' })} customClassName="modalStyle">
                <ul className={styles.popupList}>
                    <li>
                        <span>{translator(messages.dateTooltipContent1)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.dateTooltipContent2)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.dateTooltipContent3)}</span>
                    </li>
                </ul>
            </DisplayPopup>
        );
    };

    const showFieldsExplainationModal = () => {
        ModalNextProvider.showModal(
            <DisplayPopup title={translator(messages.fieldNameTooltipHeading)} closeButtonText={translator({ id: 'platform.modal.ModalService.Close' })} customClassName="modalStyle">
                <ul className={styles.popupList}>
                    <li>
                        <span>{translator(messages.fieldNameTooltipContent2)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.fieldNameTooltipContent1)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.fieldNameTooltipContent5)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.fieldNameTooltipContent3)}</span>
                    </li>
                    <li>
                        <span>{translator(messages.fieldNameTooltipContent4)}</span>
                    </li>
                </ul>
            </DisplayPopup>
        );
    };

    const docCatScreenReaderStatus = useCallback(
        ({ count }) => (isDocCatMenuOpen ? `${count} result${count === 1 ? '' : 's'} available` : ''),
        [isDocCatMenuOpen]
    );

    const handleSearchButtonKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const input = document.querySelector('#searchFilter input') || document.getElementById('searchFilter');
            if (input && (typeof searchFilter === 'undefined' || searchFilter.length === 0)) {
                input.focus();
            }
            filterClaimData();
        }
    };

    const handleFieldsTooltipKey = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showFieldsExplainationModal();
        }
    };

    const handleDateTooltipKey = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showDateSelectionModal();
        }
    };

    const override = {
        downloadSelectedButton: {
            content: (
                <Button
                    onClick={handleDownloadSelected}
                    variant="primary"
                    size="small"
                    className={styles.downloadButton}
                >
                    {translator(messages.downloadBtnText)}
                </Button>
            ),
            visible: true
        },
        warningMessage: {
            // visible: multiDownloadWarningMSG === 'MSG18' || multiDownloadWarningMSG === 'MSG25',
            content: multiDownloadWarningMSG === 'MSG18' || multiDownloadWarningMSG === 'MSG25' ? (

                <div className={`${styles.warningMessage} ${
                    multiDownloadWarningMSG === 'MSG18' ? styles.blackWarning : ''
                }`}
                >
                    {multiDownloadWarningMSG === 'MSG18'
                        ? translator(messages.limitReachedWarning)
                        : translator(messages.MSG25)}
                </div>

            ) : <></>
        },
        findSubmittedParagraph: {
            content: (
                <>
                    <p className={styles.submitText}>{translator(messages.findSubmittedParagraph)} {translator(messages.findSubmittedText)}</p>
                    <p className={styles.tipContent}>
                        <span className={styles.tip}>{translator(messages.tip)}</span>
                        <span>{translator(messages.findSubmittedText1)}</span>
                    </p>
                    <p className={styles.submitText} />
                    <p className={styles.submitText}>{translator(messages.findSubmittedText2)}</p>
                </>
            ),
        },
        mainHeading: {
            content: translator(messages.claimRelatedDocumentMainHeading)
        },
        claimRelatedDataTable: {
            data: dataTableFilter,
            noDataText: getClaimMessages(),
            role: 'alert',
            config: config,
            onConfigChange: handlePaginationConfigChange,
            manualSortBy: shouldFetchFromServer,
            autoResetSortBy: false
        },
        downloadDiv: {
            visible: !serverError || !dataTableFilter?.length === 0
        },
        msgDefaultView: {
            content: isShowDefaultViewMessage && getDefaultViewMessage(),
        },
        msgDefaultViewPhone: {
            // visible: isShowDefaultViewMessage,
            content: isShowDefaultViewMessage && getDefaultViewMessage(),
        },
        divParagragh: {
            content: (
                <>
                    <p className={styles.introParagraph}>
                        {translator(messages.claimRelatedPart1)}
                        <a
                            style={{ color: '#0D73B8' }}
                            className={styles.bluelink}
                            href={`/documentHistory/${claimNumber}`}
                            onClick={(e) => {
                                e.preventDefault();
                                renderClaimDocumentLink(e);
                            }}
                            aria-label={translator(messages.claimRelatedPart2AriaLabel)}
                        >
                            {translator(messages.claimRelatedPart2Link)}
                        </a>
                        .
                        {' '}
                        {translator(messages.claimRelatedPart3)}
                        <a
                            style={{ color: '#0D73B8' }}
                            className={`${styles.link} ${currentLanguage === 'Fr' ? styles.fippaFr : ''}`}
                            href={UtilService.commonLink('fippaLink', LocaleService.getStoredLanguage())}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={translator(messages.claimRelatedPart4Link)}
                        >
                            {translator(messages.claimRelatedPart4Link)}
                            {<img src={vector} alt="Vector" className={styles.fippaIcon} />}
                        </a>
                        .
                        {' '}
                        {translator({ id: 'claim-related.removeDoc' })}
                        <a
                            style={{ color: '#0D73B8' }}
                            className={styles.link}
                            href={`/sendmessage/${claimNumber}`}
                            onClick={(e) => {
                                e.preventDefault();
                                renderSendMessageLink(e);
                            }}
                        >
                            {translator({ id: 'claim-related.sendMessage' })}
                        </a>
                        {translator({ id: 'claim-related.sendMessageEnd' })}
                    </p>
                    <p className={styles.introParagraph}>
                        {translator({ id: 'claim-related.faqContent' })}
                        <a
                            style={{ color: '#0D73B8' }}
                            className={styles.link}
                            href={translator({ id: 'claim-related.faqUrl' })}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {translator({ id: 'claim-related.faqLink' })}
                            {<img src={vector} alt="Vector" className={styles.fippaIcon} />}
                        </a>
                        {translator({ id: 'claim-related.sendMessageEnd' })}
                    </p>
                </>
            )
        },
        checkInformation: {
            'aria-label': translator({ id: 'claim-related.checkInfoAriaLabel'})
        },
        dropDownSelect: {
            availableValues: searchByValues?.map((e) => ({
                code: e.searchByName,
                name: e.searchByName,
            })),
            value: dropdownValues,
            onValueChange: onValueChangeOfDropdown,
            showErrors: true
        },
        searchFilter: {
            value: searchFilter,
            // maxLength: getMaxLength(),
            arialabel: 'Search filter',
            className: `searchStyle ${isShowDefaultViewMessage && MSG !== "MSG11" ? styles.error : ""} `
        },
        documentCategoryLabel: {
            'aria-label': translator({ id: 'claim-related.documentCategoryAriaLabel' })
        },
        hrProgressMobile: {
            visible: !isAccord,
        },
        hrProgress: {
            visible: !isAccord,
        },
        documentCategoryDropdown: {
            availableValues: UtilService.buildDropdownOptions(DOCUMENT_CATEGORY, lang),
            value: searchFilters.documentCategory,
            onMenuOpen: () => setIsDocCatMenuOpen(true),
            onMenuClose: () => setIsDocCatMenuOpen(false),
            screenReaderStatus: docCatScreenReaderStatus
        },
        documentSourceDropdown: {
            availableValues: UtilService.buildDropdownOptions(DOCUMENT_SOURCE, lang),
            value: searchFilters.documentSource
        },
        senderInput: {
            value: searchFilters.sender
        },
        locationDetailGrid2: {
            columns: currentLanguage === 'Fr' ? ['240px', 8] : ['250px', 8]
        },
        documentDescriptionLabelInput: {
            value: searchFilters.documentDescription,
        },
        documentSourceLabel: {
            className: `${styles.searchLabel} ${styles.docSourceLabel}`,
            'aria-label': translator({ id: 'claim-related.documentSourceAriaLabel' })
        },
        fieldsNameModal: {
            src: tooltip,
            width: 18,
            'aria-label': translator({ id: 'document-history.dateToolAriaLabel' }),
            className: 'helpIcon'
        },
        dateTooltip: {
            src: tooltip,
            width: 18,
            'aria-label': translator({ id: 'document-history.dateToolAriaLabel' }),
            className: 'helpIcon'
        },
        showFieldsExplainationModal: {

        },
        fromDateError: {
            visible: error.fromDate,
            content: error.fromDate
        },
        toDateError: {
            visible: error.toDate,
            content: error.toDate
        },
        errorMessage: {
            // visible: error.commonError,
            content: error.commonError && error.commonError
        },
        fromDate: {
            isError: error.fromDate,
            selectedDate: selectedFromDate.fromDate,
            rawValue: selectedFromDate.rawFromDate,
            onChangeDate: handleFromDateChange,
            onRawChange: handleFromRawChange,
            placeholder: ''
        },
        toDate: {
            isError: error.toDate,
            selectedDate: selectedToDate.toDate,
            rawValue: selectedToDate.rawToDate,
            onChangeDate: handleToDateChange,
            onRawChange: handleToRawChange,
            placeholder: ''
        },
        advanceSearchAccordionCard: {
            header: (isOpen) => {
                setIsAccord(isOpen);
                return (
                    <>
                        <div>
                            <Chevron isOpen={isOpen} accordionOpenLabel="Advanced search" align="right" />
                        </div>
                        <div><h4 aria-label={isOpen ? translator({ id: 'claim-related.showFewerAriaLabel' }) : translator({ id: 'claim-related.showMoreAriaLabel' })}>{isOpen ? translator(messages.fewerSearchOtions) : translator(messages.moreSearchHeading)}</h4></div>
                    </>
                );
            }
        },
        ResetButton: {
            onClick: (event) => resetDefaultFn(event, true),
            'aria-label': translator({ id: 'claim-related.resetButtonAriaLabel' })
        },
        fromDateLabel: {
            'aria-label': translator({ id: 'common.fromDateAriaLabel' })
        },
        toDateLabel: {
            'aria-label': translator({ id: 'common.toDateAriaLabel' })
        },
        btnFilter: {
            'aria-label': translator({ id: 'claim-related.searchButtonAriaLabel' })
        },
        btnResetDefault: {
            'aria-label': translator({ id: 'claim-related.resetButtonAriaLabel' })
        },
        SearchButton: {
            'aria-label': translator({ id: 'claim-related.searchButtonAriaLabel' })
        },
        downloadbtnFilter: {
            'aria-label': translator({ id: 'claim-related.downloadbtnFilter' })
        },
        from: {
            path: `documentCategory${currentLanguage}`
        },
        documentDescription: {
            path: `documentDescription${currentLanguage}`
        },
        documentSource: {
            path: `channel${currentLanguage}`
        },
        sender: {
            path: `sender${currentLanguage}`
        },
        dateReceived: {
            path: `dateReceived${currentLanguage || 'En'}`
        },
        basicSearchLimitWarning: {
            visible: showBasicSearchLimitWarning,
            content: (
                <div
                    className={styles.warningBanner}
                    role="alert"
                    aria-live="assertive"
                >
                    {translator(messages.basicLimitWarning)}
                </div>
            )
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            renderClaimDocumentLink: renderClaimDocumentLink,
            renderSendMessageLink: renderSendMessageLink,
            renderFaqLink: renderFaqLink,
            renderCellDocumentCategory: renderCellDocumentCategory,
            renderCellDot: renderCellDot,
            renderCellDocumentDescription: renderCellDocumentDescription,
            renderCelldocumentSource: renderCelldocumentSource,
            renderCellSender: renderCellSender,
            renderCellDateReceived: renderCellDateReceived,
            handleSearchValueChange: handleSearchValueChange,
            filterClaimData: filterClaimData,
            resetDefault: resetDefaultFn,
            filterSubmittedDocuments,
            handleSearchFieldValueChange,
            showDateSelectionModal,
            showFieldsExplainationModal,
            renderCheckboxCell: renderCheckboxCell,
            handleDownloadSelected,
            handleFieldsTooltipKey,
            handleDateTooltipKey,
            customSortFunc,
            handleSearchButtonKeyDown
        },
        resolveComponentMap: {
            fromDatePicker: wsibDatePicker,
            toDatePicker: wsibDatePicker,
        },
    };
    return (
        <>
            <LoaderComponent showLoader={isLoading} />
            <div aria-live="polite" aria-atomic="true" className="sr-only">
                {checkboxAnnounce}
            </div>
            <div className="w100">
                {renderContentFromMetadata(uiMetadata.claimRelatedDocument, override, resolvers)}
            </div>
        </>
    );
};
export default ClaimDocumentComponent;
